export default {
  SET_COUPON(state, payload) {
    state.coupon = payload;
  },
};
